import { Component, OnDestroy, OnInit } from '@angular/core'
import { GeneralService } from 'src/app/services/general/general.service'

export interface PageLoadingContent {
  title?: string
  description?: string
}

@Component({
  selector: 'common-app-install-page-loading',
  templateUrl: './app-install-page-loading.component.html',
  styleUrls: ['./app-install-page-loading.component.scss'],
})
export class AppInstallPageLoadingComponent implements OnInit, OnDestroy {
  constructor(private generalService: GeneralService) {}

  showLoading = false

  private appInstallPageLoadingSubscription = this.generalService
    .getAppInstallPageLoadingSubject()
    .subscribe((showLoading) => {
      this.showLoading = showLoading
    })

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.appInstallPageLoadingSubscription.unsubscribe()
  }
}
